export default function getPakistanDateTime(isoString) {
    const dateObj = new Date(isoString);
  
    const date = dateObj.toLocaleDateString('en-CA', {
      timeZone: 'Asia/Karachi'
    }); // YYYY-MM-DD
  
    const time = dateObj.toLocaleTimeString('en-US', {
      timeZone: 'Asia/Karachi',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }); // hh:mm:ss AM/PM
  
    return { date, time };
  }
  